import { render, staticRenderFns } from "./CreditPoliciesPage.vue?vue&type=template&id=0eaa17fd&scoped=true&"
import script from "./CreditPoliciesPage.vue?vue&type=script&lang=js&"
export * from "./CreditPoliciesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eaa17fd",
  null
  
)

export default component.exports